import PropTypes from 'prop-types';
import Header, {headerItemsLabels} from '../../Common/Header/header';
import SlittingGrid from './SlittingGrid/slittingGrid';
import useLabels from 'infrastructure/js/hooks/useLabels';
import {PL_DialogWrapper} from 'infrastructure/js/components/Dialog/dialog';
import SlitRollsToCassettesDialog from '../../Dialogs/SlitRollsToCassettesDialog/slitRollsToCassettesDialog';

require('./slittingView.scss');

const hasSameWidthAndMaterial = (items) => {
  if (items?.length === 0) return false;

  const { widthInCentimeter, material: { id } } = items[0];

  return items.every(
    item => item.widthInCentimeter === widthInCentimeter && item.material.id === id
  );
}

export default function SlittingView(props) {

  const labels = useLabels('mat.locationpage.view.slitting.');

  const onRefreshAll = () => {
    props.actions?.locationPageActions?.reload?.();
  };

  const getHeaderItems = () => {

    let {actions, sSelectedRowsData} = props;

    let items = {
      title: labels.get('header.title'),
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.slittingViewActions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refreshAll',
          label: '',
          icon: 'pl pl-refresh',
          action: onRefreshAll,
          tooltip: headerItemsLabels.REFRESH_ALL,
        },
        {
          id: 'createSubRolls',
          label: headerItemsLabels.CREATE_SUB_ROLLS,
          icon: 'pl pl-roll-icon-blue',
          disabled: (sSelectedRowsData?.size !== 1),
          action: actions.headerActions.onCreateSubRollsClick,
          actionData: {
            preselectedAssets: sSelectedRowsData,
            parentComponent: actions.locationPageActions.reload
          },
        },
        {
          id: 'createCassettes',
          label: headerItemsLabels.SLIT_ROLLS_TO_CASSETTES,
          icon: 'pl pl-header-icon-cassette',
          disabled: (!hasSameWidthAndMaterial(sSelectedRowsData?.toJS())),
          action: actions.slitRollsToCassettesActions?.show,
          actionData: sSelectedRowsData,
        },
      ]
    }
    return items;
  }

  const headerItems = getHeaderItems();

  return (
    <div className="slitting-view">
      <Header  {...headerItems}/>

      <SlittingGrid actions={{...props.actions.slittingGridActions, ...props.actions.fetchEntitiesActions}}/>

      <PL_DialogWrapper dialogComponent={SlitRollsToCassettesDialog}
                        show={props.sSlitRollsToCassettesData.get('show')}
                        sData={props.sSlitRollsToCassettesData}
                        actions={props.actions.slitRollsToCassettesActions}
                        fetchEntitiesActions={props.actions.fetchEntitiesActions}
                        reloadParentComponent={onRefreshAll}
      />

    </div>
  )

}

SlittingView.propTypes = {
  actions: PropTypes.object.isRequired,
  sSelectedRowsData: PropTypes.object.isRequired,
  sSlitRollsToCassettesData: PropTypes.object.isRequired,
};
